export enum BassType { Bass = "Bass", Convertor = "Convertor", Standard = "Standard" }